<template>
  <div>
    <Head title="International Purchase Orders" />
    <div class="flex items-center justify-between mb-6 mt-6 overflow-x-auto">
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-orange-400 hover:text-orange-600" :href="`/international/purchaseOrders/${purchaseOrder.id}`">
          International Purchase Orders
        </Link>
        <span class="text-orange-400 font-medium">/</span> Shipping Information
      </h1>
      <div class="flex items-end justify-end space-x-3">
        <Link v-show="purchaseOrder.status ==='Booked'" class="btn-orange" :href="`/international/purchaseOrders/${purchaseOrder.id}/edit-booked-order`">
          <span>Edit</span>
        </Link>
      </div>
    </div>
    <div class="flex items-center justify-center bg-white-100">
      <div class="w-full bg-white shadow-lg">
        <div class="flex w-full">
          <div class="w-full overflow-x-auto">
            <table class="w-full border-collapse border border-gray-700 border-slate-700">
              <thead>
                <tr>
                  <th class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">
                    PO No.
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Document Date
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white">
                <tr>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">{{ purchaseOrder.PO_number }}</td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">{{ purchaseOrder.created_on }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="flex w-full mt-4">
          <div class="w-full overflow-x-auto">
            <table class="w-full border-collapse border border-gray-700 border-slate-700">
              <thead>
                <tr>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Item No.
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Shipment Name
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Container Number
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Goods/services offered
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-7000">
                    Quantity
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Units
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white">
                <tr  v-for="(shipping, index) in shippings" :key="shippings.id">
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">
                    {{ index + 1 }}
                  </td>
                  <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    {{ shipping.shipping_name }}
                  </td>
                  <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    {{ shipping.container_number }}
                  </td>
                  <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    {{ shipping.part_number }}: {{ shipping.goods_service_offered }}
                  </td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">
                    {{ shipping.quantity }}
                  </td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">
                    {{ shipping.unit_of_measure }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    Head,
    Link,
    Icon,
    TextInput,
  },
  layout: Layout,
  props: {
    purchaseOrder: Object,
    shippings: Array,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
  },
}
</script>
